import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Brightness4 from '@mui/icons-material/Brightness4';
import Brightness7 from '@mui/icons-material/Brightness7';
import { useTheme } from '../../contexts/theme';

/**
 * The portal's own theme switch.
 *
 * Same behaviour and the same stored preference as the staff navbar's toggle,
 * but kept separate because that one is styled for the navbar - it forces a
 * 30px icon, which would tower over the small logout button beside it here.
 */
export const PortalThemeToggle = () => {
  const { t } = useTranslation();
  const { isDarkMode, toggleDarkMode } = useTheme();

  const label = isDarkMode ? t('Light mode') : t('Dark mode');

  return (
    <Tooltip title={label}>
      <IconButton size="small" onClick={toggleDarkMode} aria-label={label}>
        {isDarkMode ? <Brightness7 fontSize="small" /> : <Brightness4 fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};
